module.exports = __webpack_public_path__ + "img/type_3.107ec699.jpg";